import React, {useEffect, useState} from "react";

function LazyBackground({src}) {
    const [sourceLoaded, setSourceLoaded] = useState("/other/skeleton/product.jpg")

    useEffect(() => {
        const img = new Image()
        img.src = src
        img.onload = () => setSourceLoaded(src)
    }, [src])

    return(
        <div className="menu-product-card-img" style={{backgroundImage: `url(${sourceLoaded})`}}></div>
    )
}

export {LazyBackground};